import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage - use for cross-session persistence
import authSlice from "./slices/authSlice";
import searchSlice from "./slices/searchSlice";
import demographicsByMemberId from "./slices/demographicsByMemberId";
import pcpByMemberId from "./slices/pcpByMemberId";
import healthplanByMemberId from "./slices/healthplanByMemberId";
import dashboardSlice from "./slices/dashboardSlice";
import userStatusReducer from "./slices/userStatusSlice";

const persistConfig = {
  key: "root",
  // Using localStorage for cross-tab session sharing and persistence
  storage: storage,
  // Don't persist loading and error states - they're transient UI states
  blacklist: ["loading", "error"],
};

const persistedAuthReducer = persistReducer(persistConfig, authSlice);

// Persist dashboard slice to avoid refetching on every visit
const dashboardPersistConfig = {
  key: "dashboard",
  // Using localStorage for cross-tab consistency
  storage: storage,
};

const persistedDashboardReducer = persistReducer(
  dashboardPersistConfig,
  dashboardSlice
);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    search: searchSlice,
    demographicsByMemberId,
    pcpByMemberId,
    healthplanByMemberId,
    dashboard: persistedDashboardReducer,
    userStatus: userStatusReducer,

    // referrals: referralSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: true,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
